module.exports = __webpack_public_path__ + "static/airservice-2-590f9b0a9ad709c24003d6f86a3eb69e.jpg";